import * as formActions from './form';
import * as modalActions from './modal';
import * as projectActions from './project';

/**
  App Actions
  ---
  ./src/actions/index.js

  - The app actions include all of the actions used by this app.

  - In this file we can choose to use only the actions that we absolutely need
  (in case this repo houses many apps).

  @returns {object} appActions
*/

const appActions = {
  ...formActions,
  ...modalActions,
  ...projectActions
};

export default appActions;



// WEBPACK FOOTER //
// ./src/actions/index.js